import styled from "styled-components";

export const RadioGroupContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  &.row {
    flex-direction: row;
    gap: 8px;
  }
`;
